import React from 'react';
import Header from '../../componentes/comuns/Header';
import Footer from '../../componentes/comuns/Footer';
import Ofertas from '../../componentes/comuns/Ofertas';
import Ofertaschips from '../../componentes/comuns/Ofertaschips';
import styles from './Pagina3.module.css';
import FaixaPlanos from '../../componentes/comuns/FaixaPlanos';


const Planos = () => {
    return (
        <>
            <Header />
            <main>
                <div>
                    <Ofertas />
                </div>
                <div>
                    <FaixaPlanos/>
                </div>
                
                <div className={styles.mainContent}>
                    <Ofertaschips />
                </div>

            </main>
            <Footer />
        </>
    );
}

export default Planos;